import React, { Fragment } from "react";
import Helmet from "react-helmet";
import Link from "gatsby-link";
import Header from "../../components/Header";
import TourDisplay from "../../components/TourDisplay/TourDisplay";
import hero from '../../images/airtours__hero.jpg'
import img01 from '../../images/airtours-1.jpg'
import img02 from '../../images/airtours-2.jpg'
import img03 from '../../images/airtours-3.jpg'
import img04 from '../../images/airtours-4.jpg'
import img05 from '../../images/airtours-5.jpg'
import img06 from '../../images/airtours-6.jpg'
import airTours from "../../airTours";
 


const Page = () => (
  <Fragment>
    <Helmet
      title="Airtours | What We Offer"
      // meta={[{ name: 'description', content: '' }]}
    />
    <Header hero={hero}>
      <h1 className="t-hero">Air Tours</h1>
    </Header>
    <main id="content">
      <div className="c-golden t-context--light">
        <div className="c-golden__images c-golden__short min-laptop">
        <img src={img01} alt="" style={{ width: '50%', height: '100%' }} />
          <img src={img02} alt="" style={{ width: '50%', height: '50%' }} />
          <img src={img03} alt="" style={{ width: '50%', height: '50%' }} />
        </div>
        <div className="c-golden__content c-golden__wide">
          <ul className="c-breadcrumbs mb30">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/what-we-offer">What We Offer</Link>
            </li>
            <li>
              <Link to="/what-we-offer/airtours" activeClassName="is-active">
                Air Tours
              </Link>
            </li>
          </ul>
          <div className="c-golden__text">
            <div className="c-golden__text-col">
              <h1 className="t-h1">A bird-eye view of the American West</h1>
              <p className="t-p t-p-light mt30">
              With over 40 years of experience in offering creative touring holidays 
              to customers from all around the world, you can be assured that ATI’s 
              Air Tours have been meticulously planned with an emphasis on guest experience. 
              Covering long distances by private aircraft, Air Tour customers will enjoy more 
              time inside America’s Great National Parks. Offering a more deluxe and inclusive 
              experience, these tours have been designed to use the best mode of transportation 
              between destinations so that customers can enjoy both getting there and being there. 
              </p>
            </div>
          </div>
        </div>
      </div>
      <TourDisplay
        items={airTours}
        images={[img04, img05, img06]} text="Airtour Options:"/>
    </main>
  </Fragment>
)

export default Page



// WEBPACK FOOTER //
// ./src/pages/what-we-offer/airtours.js